// import React, { useEffect, useRef, useState } from "react";
// import avtar from "../../../assets/images/defaultavtarimg.svg";

// type AvatarItem = {
//     id: number;
//     image?: string;
//     name?: string;
// };

// interface AvatarGroupProps {
//     avatars: AvatarItem[];
//     maxVisible?: number;
// }

// const AvatarGroupTask: React.FC<AvatarGroupProps> = ({
//     avatars,
//     maxVisible = 5,
// }) => {
//     const visibleAvatars = avatars.slice(0, maxVisible);
//     const remainingAvatars = avatars.slice(maxVisible);

//     const [open, setOpen] = useState(false);
//     const dropdownRef = useRef<HTMLDivElement>(null);

//     // Close on outside click
//     useEffect(() => {
//         const handler = (e: MouseEvent) => {
//             if (
//                 dropdownRef.current &&
//                 !dropdownRef.current.contains(e.target as Node)
//             ) {
//                 setOpen(false);
//             }
//         };
//         document.addEventListener("mousedown", handler);
//         return () => document.removeEventListener("mousedown", handler);
//     }, []);

//     return (
//         <div className="relative flex items-center mr-1">
//             {visibleAvatars.map((avatar, index) => (
//                 <div
//                     key={avatar?.id}
//                     className={`relative z-[${50 - index}] -ml-3 first:ml-0`}
//                 >
//                     <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center border-1 border-white">
//                         <img
//                             src={avatar?.image || avtar}
//                             alt="avatar"
//                             className="w-7 h-7 rounded-full object-cover"
//                         />
//                     </div>
//                 </div>
//             ))}

//             {remainingAvatars.length > 0 && (
//                 <div className="ml-1 relative" ref={dropdownRef}>
//                     {/* +N BUTTON */}
//                     <button
//                         onClick={() => setOpen((p) => !p)}
//                         className="w-9 h-9 rounded-full border-2 border-[#E6E6E6] bg-white flex items-center justify-center font-semibold text-sm text-black shadow-sm hover:!bg-[#F9F6FF]"
//                     >
//                         +{remainingAvatars.length}
//                     </button>

//                     {/* DROPDOWN */}
//                     {open && (
//                         <div className="absolute right-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
//                             <div className="max-h-64 overflow-y-auto p-2">
//                                 {avatars.map((user) => (
//                                     <label
//                                         key={user.id}
//                                         className="flex items-center gap-3 px-2 py-2 rounded hover:bg-gray-100 cursor-pointer"
//                                     >
//                                         <input
//                                             type="checkbox"
//                                             className="h-4 w-4 accent-gray-700"
//                                         />
//                                         <img
//                                             src={user.image || avtar}
//                                             className="w-6 h-6 rounded-full"
//                                             alt={user.name || "-"}
//                                         />
//                                         <span className="text-sm text-gray-800">
//                                             {user.name ?? "-"}
//                                         </span>
//                                     </label>
//                                 ))}
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AvatarGroupTask;
import React, { useEffect, useRef, useState } from "react";

type AvatarItem = {
    id: string;
    image?: string;
    name?: string;
};

interface AvatarGroupProps {
    avatars: AvatarItem[];
    selectedIds: string[];
    onChange: (ids: string[]) => void;
    maxVisible?: number;
    viewOnly?: boolean; // If true, hides checkboxes and disables selection
}

const AvatarGroupTask: React.FC<AvatarGroupProps> = ({
    avatars,
    selectedIds,
    onChange,
    maxVisible = 5,
    viewOnly = false,
}) => {
    const visibleAvatars = avatars.slice(0, maxVisible);
    const remainingAvatars = avatars.slice(maxVisible);

    const [open, setOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target as Node)
            ) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const toggleUser = (id: string) => {
        const next = selectedIds.includes(id)
            ? selectedIds.filter(x => x !== id)
            : [...selectedIds, id];

        onChange(next);
        setOpen(false); // ✅ CLOSE DROPDOWN AFTER SELECTION
    };

    const getInitials = (name: string) => {
        if (!name) return "?";

        const clean = name.trim().replace(/\s+/g, " ");
        const words = clean.split(" ");

        if (words.length === 1) {
            return clean.charAt(0).toUpperCase();
        }

        return (words[0][0] + words[1][0]).toUpperCase();
    };

    const colors = [
        "bg-red-500",
        "bg-green-500",
        "bg-blue-500",
        "bg-purple-500",
        "bg-yellow-500",
        "bg-pink-500",
        "bg-indigo-500",
    ];

    const getColor = (name: string) =>
        colors[name.charCodeAt(0) % colors.length];

    const InitialsAvatar = ({ name }: { name: string }) => {
        const [show, setShow] = useState(false);

        return (
            <div
                className="relative"
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
            >
                <div
                    className={`w-9 h-9 rounded-full border-2 border-white
                ${getColor(name)} flex items-center justify-center
                text-xs text-white font-medium`}
                >
                    {getInitials(name)}
                </div>

                {/* {show && (
                    <div className="absolute z-[9999] -top-9 left-1/2 -translate-x-1/2
                    whitespace-nowrap rounded bg-white px-2 py-1 text-xs text-black
                    shadow-md max-w-28 truncate">
                        {name}
                    </div>
                )} */}
            </div>
        );
    };


    return (
        <div 
            className="relative flex items-center mr-1"
            onClick={(e) => e.stopPropagation()}
        >
            {/* VISIBLE AVATARS */}
            {visibleAvatars.map((avatar, index) => {
                const active = selectedIds.includes(avatar.id);

                const AvatarContent = () => (
                    <>
                        {avatar.image ? (
                            <img
                                src={avatar.image}
                                alt={avatar.name}
                                className="w-9 h-9 border-2 border-white rounded-full object-cover"
                            />
                        ) : (
                            <InitialsAvatar name={avatar.name ?? "?"} />
                        )}
                    </>
                );

                return viewOnly ? (
                    <div
                        key={avatar.id}
                        className={`relative -ml-3 first:ml-0 w-9 h-9 rounded-full transition`}
                        style={{ zIndex: 50 - index }}
                        title={avatar.name}
                    >
                        <AvatarContent />
                    </div>
                ) : (
                    <button
                        key={avatar.id}
                        type="button"
                        onClick={() => toggleUser(avatar.id)}
                        className={`relative -ml-3 first:ml-0 w-9 h-9 rounded-full transition`}
                        style={{ zIndex: 50 - index }}
                        title={avatar.name}
                    >
                        <AvatarContent />
                    </button>
                );
            })}

            {/* +N DROPDOWN */}
            {remainingAvatars.length > 0 && (
                <div className="ml-1 relative" ref={dropdownRef}>
                    <button
                        type="button"
                        onClick={() => setOpen(o => !o)}
                        className="w-10 h-10 rounded-full border-2 border-gray-300 bg-white
                        flex items-center justify-center font-semibold text-xs
                        hover:bg-gray-100"
                    >
                        +{remainingAvatars.length}
                    </button>

                    {open && (
                        <div 
                            className="absolute right-0 mt-2 min-w-64 bg-white border
                            border-gray-200 rounded-lg shadow-lg z-50"
                        >
                            <div className="max-h-64 overflow-y-auto p-2">
                                {avatars.map(user => (
                                    <div
                                        key={user.id}
                                        className={`w-full flex items-center gap-3 px-2 py-2 rounded ${
                                            viewOnly ? "" : "hover:bg-gray-100 cursor-pointer"
                                        }`}
                                        onClick={viewOnly ? undefined : () => toggleUser(user.id)}
                                    >
                                        {!viewOnly && (
                                            <input
                                                type="checkbox"
                                                title="Checked"
                                                checked={selectedIds.includes(user.id)}
                                                readOnly
                                            />
                                        )}

                                        {user.image ? (
                                            <img
                                                src={user.image}
                                                alt={user.name || "User"}
                                                className="w-6 h-6 rounded-full"
                                            />
                                        ) : (
                                            <InitialsAvatar name={user.name ?? "?"} />
                                        )}

                                        <span className="text-sm text-gray-800 truncate">
                                            {user.name ?? "-"}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AvatarGroupTask;
